import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './componenent/header/Header'
import SubHeader from './componenent/sub-header/SubHeader'
import MainTable from './componenent/main-table/MainTable'
import Footer from './componenent/footer/Footer'
import SuccessMessagePopup from '../comonComponent/success-message-popup/SuccessMessagePopup'
import ErrorMessagePopup from '../comonComponent/error-message-popup/ErrorMessagePopup'

function Layout1d() {
  return (
    <table className='h-scree' width="100%" style={{userSelect: "none",color:"black",backgroundColor:"#d9d9d9"}}>
      <tbody>
          {<Outlet />}
            <Header />
            {/* <SubHeader />*/}
            <MainTable />
            {/* <Footer />  */}
      </tbody>
    </table>
  )
}

export default Layout1d